import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLocation } from "react-router-dom";
import { elements } from "chart.js";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

const TeamofQuarterForm = () => {
  const location = useLocation();
  let path = location.pathname;

  const searchParams = new URLSearchParams(location.search);
  const [file, setFile] = useState(null);
  const nominationid = searchParams.get("awid");

  const [currentTemplate, setCurrentTemplate] = useState([]);
  const [justifications, setJustifications] = useState({
    Creativity: [],
    Profitability: [],
    Contribution_to_OmanSATS: [],
    Last_three_years_performance_appraisal_rate: [],
    Personal_Details: [],
  });
  const [teamMembers, setTeamMembers] = useState([]);
  const [awardDatavalues, setAwardDataValues] = useState([]);
  const [awardDatavaluesdesignation, setAwardDataValuesDesignation] = useState(
    []
  );
  const [showToast, setShowToast] = useState(false);

  const navigate = useNavigate();
  const usernameRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [year, setYear] = useState(null);
  const [designation, setDesignation] = useState([]);
  const handleRemoveAllOptions = () => {
    setAllEmployees([]);
  };

  const [allemployees, setAllEmployees] = useState([]);
  const deptid = localStorage.getItem("departmentid");
  const [employeesData, setEmployeesData] = useState([]);
  const [employeeinitalsdata, setEmployeesInitialData] = useState([]);
  const [assigneevalues, setAssigneeValues] = useState(null);
  const [isdeptselected, setIsDeptselected] = useState(false);
  const [designationData, setDesignationData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [options, setOptions] = useState([]);
  const [title, setTitle] = useState("");
  const [isMultiipleAssigneeNeeded, setisMultiipleAssigneeNeeded] =
    useState(true);
  const [selAssigneeVal, setselAssigneeVal] = useState("");
  const [department, setDepartment] = useState([]);

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        let response = [];
        let template = [];
        let jsontemplate = [];

        if (path === "/leaderofquarter") {
          setTitle("Leader");
          setisMultiipleAssigneeNeeded(false);
        } else {
          setTitle("Team");
          setisMultiipleAssigneeNeeded(true);
        }

        if (nominationid != null) {
          if (path === "/leaderofquarter") {
            response = await axios.get(
              `${baseURL}/getleadernomination?nid=` + nominationid
            );
          } else {
            response = await axios.get(
              `${baseURL}/getteamnomination?nid=` + nominationid
            );
          }
          template = response.data.template;
          setAwardDataValues(template);
          jsontemplate = JSON.parse(template.question_answers);
          setCurrentTemplate(jsontemplate);
        } else {
          response = await axios.get(`${baseURL}/getStarTemplate`);
          template = response.data.template[0];
          jsontemplate = JSON.parse(template.questionsjson);
          setCurrentTemplate(jsontemplate);
        }
      } catch (error) {
        console.error("Error fetching template:", error);
      }
      fetchDesignations();
    };

    fetchTemplate();
  }, [nominationid]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getdepartments`
        );
        setOptions(response.data.departments);
        setDepartment(deptid);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();

    // fetchSmartgoals();
  }, []);
  const fetchDesignations = async () => {
    try {
      const resp = await axios.get(
      `${baseURL}/getdeignationsfordept?did=` + deptid
      );
      if (resp.status === 200) {
        // Filter out "Line Manager" designation using indexOf
        const designations = resp.data.designations;
        const filteredDesignations = [];

        // Use forEach to filter out "Line Manager"
        designations.forEach((desigobject) => {
          if (typeof desigobject === "object") {
            if (
              desigobject.designation.trim().toLowerCase() !== "line manager"
            ) {
              filteredDesignations.push(desigobject);
            }
          }
        });

        setDesignationData(filteredDesignations);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const deisgnationChange = async (designationid) => {
    try {
      //alert(designationid);
      let selecteddesignation = designationid;
      //alert("selected  designation"+selecteddesignation);
      setDesignation(selecteddesignation);
      // alert("designation val"+designation);
      const resp = await axios.get(
        `${baseURL}/getassigneesbydesignationandept?id=` +
          designationid +
          "&did=" +
          deptid
      );
      if (resp.statusText === "OK") {
        //alert("after axios selected designation:"+designation);
        setEmployeesData(resp.data.employees);

        setEmployeesInitialData(resp.data.employees);

        setAssigneeValues(
          employeesData.map((employee) => employee.id).join(",")
        );

        setIsDeptselected(true);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  useEffect(() => {
    const fetchAssignees = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getallassigneesb`
        );
        setAllEmployees(response.data.employees);
        setEmployeesData(response.data.employees);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchAssignees();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const id = localStorage.getItem("employeeid");
        const response = await axios.get(
          `${baseURL}/getteamlist?id=` + id
        );
        const data = response.data;
        let arrTeamdata = data.team;
        setTeamMembers(arrTeamdata);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchData();
  }, []);

  const handleJustificationChange = (category, index, value) => {
    const newJustifications = { ...justifications };
    newJustifications[category][index] = { answer: value };
    setJustifications(newJustifications);
  };

  const handleSubmit = async (values) => {
    if (values.assignees) {
      setFormData(values); // Store form data before displaying the modal
      setShowModal(true); // Show the confirmation modal
    } else {
      alert("Please select Employee for Nomination");
      return;
    }

    // if (values.assignees) {
    //     setFormData(values); // Store form data before displaying the modal
    //     setShowModal(true); // Show the confirmation modal
    // } else {
    //     if (formData.assignees2) {
    //         setFormData(values); // Store form data before displaying the modal
    //         setShowModal(true); // Show the confirmation modal
    //     } else {
    //         alert("Please select Employee for Nomination");
    //         return;
    //     }
    //
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      let id = localStorage.getItem("employeeid");

      let json_date = {};
      if (currentTemplate) {
        for (let key in currentTemplate) {
          if (currentTemplate.hasOwnProperty(key)) {
            if (key === "templateid" || key === "author") {
              json_date[key] = currentTemplate[key];
            } else {
              json_date[key] = [
                {
                  text: currentTemplate[key][0].text,
                  justification: justifications[key] || "",
                },
              ];
            }
          }
        }
      } else {
        console.error("currentTemplate is not defined");
      }

      let jsondata = JSON.stringify(json_date);

      const formData2 = {
        employeeid: formData.assignees,
        recommended_by: id,
        question_answers: jsondata,
        role: formData.role,
        month_year: year,
      };

      let updatedFormData = { ...formData2 };
      let response;

      if (file !== null) {
        updatedFormData.certificate = file;
      }

      let formDataToSend = new FormData();

      if (file !== null) {
        for (let key in updatedFormData) {
          formDataToSend.append(key, updatedFormData[key]);
        }
        if (title === "Team") {
          response = await fetch(`${baseURL}/addteamofquarter`, {
            method: "POST",
            body: formDataToSend,
          });
        } else if (title === "Leader") {
          response = await fetch(`${baseURL}/addleaderofquarter`, {
            method: "POST",
            body: formDataToSend,
          });
        }
      } else {
        if (title === "Team") {
          response = await axios.post(
            `${baseURL}/addteamofquarter`,
            formData2,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        } else if (title === "Leader") {
          response = await axios.post(
            `${baseURL}/addleaderofquarter`,
            formData2,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        }
      }

      if (response.status >= 200) {
        setFormData(null);
        setShowModal(false);
        setShowToast(true);

        if (title === "Team") {
          setTimeout(() => {
            setShowToast(false);

            window.location.href = "/teamofquarter";
          }, 3000);
        } else if (title === "Leader") {
          setTimeout(() => {
            setShowToast(false);

            window.location.href = "/leaderofquarter";
          }, 3000);
        }
      } else {
        console.error("Form submission failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  if (!currentTemplate) {
    return <div>Loading...</div>;
  }

  const generateYearOptions = () => {
    const options = [];
    const currentYear = new Date().getFullYear();
    const quarters = [
      "Q1 (Jan-Mar)",
      "Q2 (Apr-Jun)",
      "Q3 (Jul-Sep)",
      "Q4 (Oct-Dec)",
    ];

    for (let year = currentYear - 1; year <= currentYear; year++) {
      quarters.forEach((quarter, index) => {
        options.push({
          value: `${year}-Q${index + 1}`,
          label: `${quarter} - ${year}`,
        });
      });
    }

    return options;
  };

  const handleChangeYear = (selectedOption) => {
    setYear(selectedOption.value);
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      let fileval = e.target.files[0];
      setFile(fileval);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          assignees: [],
          // justificationtxt: '',
          // recommendationtxt: '',
          role: "",
          overallrating: "",
          month_year: "",
          certificate: "",
        }}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, setFieldValue, touched, errors }) => (
          <Form>
            <h4>{title}&nbsp;of Quarter Nomination:]</h4>
            <div className="d-flex flex-wrap">
              <div class="col-lg-5 mt-2">
                <label>
                  {title} : {awardDatavalues.designation_name}
                </label>

                <input type="hidden" name="designationid" value={designation} />
                {awardDatavalues && awardDatavalues.month_year ? null : (
                  <>
                    <label>Select Designation : </label>

                    <select
                      className="form-select form-control"
                      name="role"
                      disabled={
                        awardDatavalues && awardDatavalues.designation
                          ? true
                          : false
                      }
                      placeholder="Select Designation"
                      value={(values.role = designation)}
                      onChange={(e) => {
                        handleRemoveAllOptions();
                        deisgnationChange(e.target.value);
                        setDesignation(e.target.value);
                      }}
                    >
                      <option valuue="">Select Designation</option>
                      {designationData.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.designation}
                        </option>
                      ))}
                    </select>
                  </>
                )}
              </div>

              <div className="col-lg-5 mt-2 ml-5">
                <label>Assigness : {awardDatavalues.employee_names}</label>
                {awardDatavalues && awardDatavalues.month_year ? null : (
                  <>
                    <label>
                      Select Assignees <span className="text-danger">*</span>
                    </label>

                    <Select
                      isMulti={isMultiipleAssigneeNeeded}
                      name="assignees2"
                      options={employeeinitalsdata.map((employee) => ({
                        value: employee.id,
                        label: `${employee.FirstName} ${
                          employee.LastName ? employee.LastName : ""
                        } - ${employee.employeeid}`,
                      }))}
                      value={
                        isdeptselected
                          ? employeeinitalsdata.map((employee) => ({
                              value: employee.id,
                              label: `${employee.FirstName} ${
                                employee.LastName ? employee.LastName : ""
                              } - ${employee.employeeid}`,
                            }))
                          : selectedOptions
                      }
                      onChange={(selectedOptions) => {
                        let selectedValues = "";
                        if (isMultiipleAssigneeNeeded) {
                          selectedValues = selectedOptions
                            ? selectedOptions.map((option) => option.value)
                            : [];
                          setselAssigneeVal(selectedValues.join(","));
                        } else {
                          selectedValues = selectedOptions
                            ? selectedOptions.value
                            : "";
                          setselAssigneeVal(
                            selectedOptions ? selectedOptions.value : null
                          );
                        }
                        setFieldValue("assignees", selectedValues);
                        setFieldValue("assignees2", selectedValues);
                        setIsDeptselected(false);
                        setSelectedOptions(selectedOptions);
                      }}
                      isClearable={true} // This will allow the select to be cleared
                    />
                  </>
                )}

                {touched.assignees && errors.assignees ? (
                  <div className="text-danger">{errors.assignees}</div>
                ) : null}
                <input
                  type="hidden"
                  name="assignees"
                  value={
                    (values.assignees = isMultiipleAssigneeNeeded
                      ? employeeinitalsdata
                        ? employeeinitalsdata
                            .map((employee) => employee.id)
                            .join(",")
                        : ""
                      : selAssigneeVal)
                  }
                />
              </div>

              <div className="col-lg-5 mt-2 pt-3">
                <label>
                  {" "}
                  Quarter of the Year : {awardDatavalues.month_year}
                </label>
                <br />
                {awardDatavalues && awardDatavalues.month_year ? null : (
                  <Select
                    name="month_year"
                    options={generateYearOptions()}
                    value={
                      values.month_year
                        ? {
                            value: values.month_year,
                            label: generateYearOptions().find(
                              (option) => option.value === values.month_year
                            )?.label,
                          }
                        : null
                    }
                    isMulti={false}
                    onChange={(selectedOption) => {
                      const selectedValue = selectedOption.value;
                      setFieldValue("month_year", selectedValue);
                      setYear(selectedValue);
                      //alert(selectedValue);
                    }}
                  />
                )}
              </div>
            </div>
            <h4 className="mt-3 pt-3 pb-3 fs-3">Business Case</h4>

            <table className="w-100 mt-2">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.Creativity &&
                  currentTemplate.Creativity.map((question, index) => (
                    <tr key={index}>
                      <td className="w-50">
                        <h3 className="pt-3 mt-2">Creativity</h3>
                        <label className="mt-2">{question.text}</label>
                      </td>
                      <td className="p-2">
                        <textarea
                          className="w-75 m-1 p-1  float-end"
                          value={
                            justifications.Creativity[index]?.answer ||
                            question.justification[index]?.answer ||
                            ""
                          }
                          onChange={(e) =>
                            handleJustificationChange(
                              "Creativity",
                              index,
                              e.target.value
                            )
                          }
                          disabled={
                            awardDatavalues && awardDatavalues.month_year
                              ? true
                              : false
                          }
                          rows="6"
                          placeholder="Justification"
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            <table className="w-100 mt-2 pt-3">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.Profitability &&
                  currentTemplate.Profitability.map((question, index) => (
                    <tr key={index}>
                      <td className="w-50">
                        <h3 className="pt-3 mt-2">Profitability</h3>
                        <label className="mt-2">{question.text}</label>
                      </td>
                      <td className="p-2">
                        <textarea
                          className="w-75 m-1 p-1 float-end"
                          value={
                            justifications.Profitability[index]?.answer ||
                            question.justification[index]?.answer ||
                            ""
                          }
                          onChange={(e) =>
                            handleJustificationChange(
                              "Profitability",
                              index,
                              e.target.value
                            )
                          }
                          disabled={
                            awardDatavalues && awardDatavalues.month_year
                              ? true
                              : false
                          }
                          rows="6"
                          placeholder="Justification"
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            <table className="w-100 pt-3 mt-2">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.Contribution_to_OmanSATS &&
                  currentTemplate.Contribution_to_OmanSATS.map(
                    (question, index) => (
                      <tr key={index}>
                        <td className="w-50">
                          <h3 className="pt-3 mt-2">
                            Contribution to Oman SATS
                          </h3>
                          <label className="mt-2">{question.text}</label>
                        </td>
                        <td className="p-2">
                          <textarea
                            className="w-75 m-1 p-1 float-end"
                            value={
                              justifications.Contribution_to_OmanSATS[index]
                                ?.answer ||
                              question.justification[index]?.answer ||
                              ""
                            }
                            onChange={(e) =>
                              handleJustificationChange(
                                "Contribution_to_OmanSATS",
                                index,
                                e.target.value
                              )
                            }
                            disabled={
                              awardDatavalues && awardDatavalues.month_year
                                ? true
                                : false
                            }
                            rows="6"
                            placeholder="Justification"
                          />
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>

            <table className="w-100 pt-3 mt-2">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.Last_three_years_performance_appraisal_rate &&
                  currentTemplate.Last_three_years_performance_appraisal_rate.map(
                    (question, index) => (
                      <tr key={index}>
                        <td className="w-50">
                          <h3 className="pt-3 mt-2">
                            Last Three Years Performance Appraisal Rate
                          </h3>
                          <label className="mt-2">{question.text}</label>
                          <label className="mt-2">
                            {question.justification[index].answer}
                          </label>
                        </td>
                        <td className="p-2">
                          <textarea
                            className="w-75 m-1 p-1 float-end"
                            value={
                              justifications
                                .Last_three_years_performance_appraisal_rate[
                                index
                              ]?.answer ||
                              question.justification[index].answer ||
                              ""
                            }
                            onChange={(e) =>
                              handleJustificationChange(
                                "Last_three_years_performance_appraisal_rate",
                                index,
                                e.target.value
                              )
                            }
                            disabled={
                              awardDatavalues && awardDatavalues.month_year
                                ? true
                                : false
                            }
                            rows="6"
                            placeholder="Justification"
                          />
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>

            <table className="w-100 pt-3 mt-2">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.Personal_Details &&
                  currentTemplate.Personal_Details.map((question, index) => (
                    <tr key={index}>
                      <td className="w-50">
                        <h3 className="pt-3 mt-2">Personal Details</h3>
                        <label className="mt-2">{question.text}</label>
                      </td>
                      <td className="p-2">
                        <textarea
                          className="w-75 m-1 p-1 float-end"
                          value={
                            justifications.Personal_Details[index]?.answer ||
                            question.justification[index].answer ||
                            ""
                          }
                          onChange={(e) =>
                            handleJustificationChange(
                              "Personal_Details",
                              index,
                              e.target.value
                            )
                          }
                          disabled={
                            awardDatavalues && awardDatavalues.month_year
                              ? true
                              : false
                          }
                          rows="6"
                          placeholder="Justification"
                        />
                      </td>
                    </tr>
                  ))}
                <tr>
                  {awardDatavalues && awardDatavalues.month_year ? (
                    <td colSpan="2">
                      <a
                        href={`${baseURL}/getcertifcate?filename=${awardDatavalues.certifilename}`}
                        download // Add the download attribute
                      >
                        <h6> View Certificate</h6>
                      </a>
                    </td>
                  ) : (
                    <>
                      <td>Upload Certificate</td>
                      <td>
                        <input
                          value={values.certificate}
                          id="file"
                          type="file"
                          onChange={handleFileChange}
                        />
                        {file && <p>{file.name}</p>}
                      </td>
                    </>
                  )}
                </tr>
              </tbody>
            </table>

            <div className="col-lg-11 text-end mt-4 pb-3">
              {awardDatavalues && awardDatavalues.month_year ? (
                <Button
                  className="border-0 mt-2 p-1 btn-#8d3523 savebtn w-25"
                  type="button"
                  onClick={() => (window.location.href = "/teamofquarterlist")}
                >
                  Go Back to List
                </Button>
              ) : (
                <>
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    type="button"
                    className="btn cancelbtn ml-2"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </Form>
        )}
      </Formik>
      <div>
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Submission</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to submit the form?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmSubmit}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TeamofQuarterForm;
